import SupervisingLayout from "@/app/(app)/(crew)/supervising/_layout";

export default SupervisingLayout;
